import Vue from 'vue';
import QuizApp from './quizAppStorefront.vue';

import { getVuexStore } from './store/store.js';

/*
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

/*
 * Search for all elementes with data-qid
 * and initialize each quiz as a Vue.js app
 * each one with its own Vuex store
 */

var allQuizes = document.querySelectorAll('[data-qid]');
var isPreview = document.querySelectorAll('[data-preview]');
if (allQuizes) {
    for (var quiz = 0; quiz < allQuizes.length; quiz++) {
        if (Object.prototype.hasOwnProperty.call(allQuizes, quiz)) {
            var osfquiz = new Vue({
                el: '#' + allQuizes[quiz].getAttribute('id'),
                store: getVuexStore(),
                render(h) {
                    return h(QuizApp, {
                        props: {
                            qid: allQuizes[quiz].getAttribute('data-qid'),
                            preview: isPreview.length > 0
                        }
                    });
                }
            });
        }
    }
}
